import { render, staticRenderFns } from "./TableStatisticsBar.vue?vue&type=template&id=563e0a0f&"
import script from "./TableStatisticsBar.vue?vue&type=script&lang=js&"
export * from "./TableStatisticsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports